import React, { Component } from 'react';
import './Headercontent.css';
import logo from '../assets/images/PruXpress_Logo.png';


export default function HeaderContent (){
    return(
        <header className="header-container">
			<img src={logo} className="Prudential_Logo" alt="Prudential Logo"
				aria-label="Prudential logo" />
		</header>
    );
}